export default "__VITE_ASSET__4JzN9O7R__"